import { createAction, props } from '@ngrx/store';

import { UserAccountHomeDto } from '../core/dtos/dto';

export const loadMyAccount = createAction('[My Account] Load My Account', props<{ myAccount: UserAccountHomeDto }>());

export const clearMyAccount = createAction('[My Account] Clear My Auth');

